import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { brandsOpenApi, ROUTE_PATHS } from '@constants';
import { FEED_SUPPORTED_PLATFORMS } from '@enums';
import { useNotification } from '@hooks';
import { getFeedErrorMessage } from '@pages/Feed/utils/getFeedErrorMessage';
import { Loader } from '@ui';
import { axiosBoa } from '@utils';
import { StyledWrapper } from '../../Oauth/BigCommerce/Callback';

const MetaFeedCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const notification = useNotification();

    useEffect(() => {
        (async () => {
            try {
                const code = searchParams.get('code');
                const state = searchParams.get('state');
                const error = searchParams.get('error');

                if (error) {
                    notification.error({
                        message: 'Something went wrong'
                    });
                    navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_MANUAL_FEED);
                    return;
                }

                if (!code || !state) {
                    notification.error({
                        message: 'Something went wrong'
                    });
                    navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_MANUAL_FEED);
                    return;
                }

                const response = await axiosBoa.get(brandsOpenApi.feedOauth.callback(FEED_SUPPORTED_PLATFORMS.META), {
                    params: {
                        code,
                        state
                    }
                });

                if (response.success) {
                    navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_MANUAL_FEED_META_CATALOGS);
                } else {
                    notification.error({
                        message: 'Something went wrong'
                    });
                    navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_MANUAL_FEED);
                }
            } catch (error) {
                notification.error({
                    message: 'Meta connection failed',
                    description: getFeedErrorMessage(error),
                    duration: 10
                });
                navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_MANUAL_FEED);
            }
        })();
    }, [searchParams, navigate, notification]);

    return (
        <StyledWrapper justify='center' align='center'>
            <Loader size='120px' />
        </StyledWrapper>
    );
};

export default MetaFeedCallback;
